export const DATE_PICKER_FIELD_FORMAT = 'YYYY-MM-DD';

/**
 * Minimum valid birthdate for membership registration (dynamically computed as 110 years ago to match BE validation)
 * - Use MIN_BIRTHDATE_ISO for React components with internationalized/date package
 * - Use MIN_BIRTHDATE_DISPLAY for Ember validators and user-facing formats
 */
const MIN_BIRTHDATE_YEAR = new Date().getFullYear() - 110;
export const MIN_BIRTHDATE_ISO = `${MIN_BIRTHDATE_YEAR}-01-01`;
export const MIN_BIRTHDATE_DISPLAY = `1/1/${MIN_BIRTHDATE_YEAR}`;
